<template>
  <div>
    <el-input
      ref="input"
      v-model="value"
      type="textarea"
      :rows="rows"
      v-bind="params.inputProps"
      :style="{minWidth: minWidth + 'px!important'}"
      @blur="onBlur"
      @dblclick.native="showAdvanceTextDialog"
    />
    <!-- 文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button type="primary" @click="finishAdavnceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'
import { getLength } from '@/utils'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
export default Vue.extend({
  name: 'CargoAgGridAdvanceTextEditor',
  components: {
    cargoRichTextarea
  },
  mixins: [TableKeyboardNav],
  data() {
    return {
      value: '',
      type: 'input',
      disableEnter: true,
      minWidth: 200,
      rows: 5,
      advanceTextDialog: {
        enable: false,
        visible: false,
        title: '',
        value: ''
      }
    }
  },
  created() {
    console.log('oninputeditor')
    this.value = this.params.value
    if (this.params.fitContent) {
      const fontSize = this.params.fontSize || 12
      const lines = String(this.value).split('\n')
      // 设置宽度
      for (const line of lines) {
        const width = this.getTextWidth(line, fontSize)
        if (width > 200) {
          this.minWidth = 400
          break
        }
      }
      // 设置行数
      this.rows = 1 // 留出一行，作为空余
      for (const line of lines) {
        const width = this.getTextWidth(line, fontSize) + 50 // 留出部分宽度，容纳误差
        this.rows += Math.ceil(width / this.minWidth)
      }
      // 最小行数为5
      if (this.rows < 5) {
        this.rows = 5
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        this.$refs.input.select()
      }
    })
    setTimeout(() => {
      this.advanceTextDialog.enable = true
    }, 500)
  },
  methods: {
    getValue() {
      return this.value
    },
    onBlur() {
      this.$nextTick(() => {
        if (!this.advanceTextDialog.visible) {
          this.params.api.stopEditing()
        }
      })
    },
    isPopup() {
      return true
    },
    getTextWidth(text, fontSize) {
      return getLength(String(text)) * 0.5 * fontSize // 文本字节数 * 0.5 * font-size
    },
    showAdvanceTextDialog() {
      if (!this.advanceTextDialog.enable) {
        return
      }
      this.advanceTextDialog.title = this.params.title || ''
      this.advanceTextDialog.value = this.value
      this.advanceTextDialog.visible = true
    },
    finishAdavnceText() {
      this.value = this.advanceTextDialog.value
      this.advanceTextDialog.visible = false
    }
  }
})
</script>
